// Cognito Forms embedding configuration
export const COGNITO_FORMS_CONFIG = {
  dataKey: 'tNkF4rkQk0yrDwNN5i4Vyw',
  dataForm: '6'
};

// Debug panel visibility (toggle via bug icon in UI)
export const SHOW_DEBUG_PANEL = false;

// Form field mappings (Cognito Forms internal field names)
export const FORM_FIELD_NAMES = {
  userEmail: 'Email',
  userEmailForReceipt: 'userEmailForReceipt',
  userName: 'Name',
  userPrincipalName: 'UserPrincipalName',
  tenantId: 'tenantIDFromAuth',
  userId: 'UserId',
};
